import type { ReactNode } from 'react';

import type { Me } from '../../api/generated/model';
import { TermsPage } from './TermsPage';

export interface TermsGateProps {
  readonly me: Me;
  readonly children: ReactNode;
}

/**
 * Portao de aceite.
 *
 * Enquanto `pendingTerms` nao estiver vazio, a navegacao fica presa aqui. O
 * portao **nao decide** o que esta pendente: quem decide e o servidor, e a tela
 * apenas obedece a lista que recebeu. Calcular pendencia no cliente seria a
 * regra de negocio migrando para onde ela nao pode ser garantida.
 */
export function TermsGate({ me, children }: TermsGateProps) {
  if (me.pendingTerms.length > 0) {
    return <TermsPage pendingTerms={me.pendingTerms} />;
  }
  return <>{children}</>;
}
